import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../common/Modal';

import { t } from '../../../../modules/infra/i18n';

const MessageModal = ({ close, message, title }) => (
  <Modal title={title} close={close} showCloseButton>
    <div className="u-max-width-430 u-pv u-text-center u-margin-auto">{message}</div>
    <div className="c-separator" />
    <div className="u-text-center u-mv">
      <button type="button" className="c-btn c-btn--medium u-width-80" onClick={close}>
        {t('common:modal.confirm_button')}
      </button>
    </div>
  </Modal>
);
MessageModal.propTypes = {
  close: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default MessageModal;
